import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { apiPost } from './api'

const firebaseConfig = {
  apiKey: 'AIzaSyDjjBIzO9YTIlB4GFSqDinaY1OtDAVZKzo',
  authDomain: 'evo-pwa.firebaseapp.com',
  projectId: 'evo-pwa',
  storageBucket: 'evo-pwa.firebasestorage.app',
  messagingSenderId: '741689627712',
  appId: '1:741689627712:web:48aa90f89d71d0c94fbba5',
}

const VAPID_KEY = 'BDHVLtC9AuxpUrN62Prd_YNKxX56krlIoBNO2icYELCZJ0agYcXiSVc-DCRep551YO6bA6DFOMwU8UhVlU75TyI'

const app = initializeApp(firebaseConfig)

let messagingInstance: ReturnType<typeof getMessaging> | null = null

function getMessagingInstance() {
  if (!messagingInstance) {
    messagingInstance = getMessaging(app)
  }
  return messagingInstance
}

/**
 * Request notification permission, get FCM token, and register it with the backend.
 */
export async function initPushNotifications(options: { requestPermission?: boolean } = {}): Promise<boolean> {
  const log = (msg: string) => {
    console.log(`[FCM] ${msg}`)
    // Store status for debugging
    localStorage.setItem('fcm_status', `${new Date().toLocaleTimeString()}: ${msg}`)
  }

  try {
    if (!('Notification' in window)) {
      log('Notifications API not supported')
      return false
    }

    let permission = Notification.permission
    log(`Permission: ${permission}`)
    if (permission === 'default' && options.requestPermission !== false) {
      permission = await Notification.requestPermission()
      log(`Permission after request: ${permission}`)
    }

    if (permission !== 'granted') {
      log('Permission denied')
      return false
    }

    // Use the main PWA service worker (which imports firebase-messaging-sw.js via importScripts)
    log('Waiting for main SW...')
    const swReg = await navigator.serviceWorker.ready
    log(`SW ready, state: ${swReg.active?.state || 'unknown'}`)

    const messaging = getMessagingInstance()
    log('Getting FCM token...')
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swReg,
    })
    if (token) {
      log(`Token obtained: ${token.substring(0, 20)}...`)
      try {
        await apiPost('/notifications/fcm-token', { token })
        localStorage.setItem('fcm_registered_token', token)
        log('Token registered with backend')
      } catch {
        log('Failed to register token with backend')
      }
      return true
    }

    log('No token received')
    return false
  } catch (err: any) {
    const msg = err?.message || String(err)
    console.error('[FCM] Init failed:', err)
    localStorage.setItem('fcm_status', `ERROR: ${msg}`)
    return false
  }
}

/**
 * Listen for foreground push messages and trigger notification store refresh.
 */
export function onForegroundMessage(callback: (payload: any) => void) {
  try {
    const messaging = getMessagingInstance()
    return onMessage(messaging, callback)
  } catch {
    return () => {}
  }
}

export function onPushTokenRefresh(callback: (token: string) => void) {
  let active = true
  const refresh = async () => {
    try {
      const swReg = await navigator.serviceWorker.ready
      const token = await getToken(getMessagingInstance(), {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: swReg,
      })
      const previousToken = localStorage.getItem('fcm_registered_token')
      if (active && token && token !== previousToken) callback(token)
    } catch {
      // Refresh is best-effort; the next authenticated app start will register again.
    }
  }
  const interval = window.setInterval(() => void refresh(), 60 * 60 * 1000)
  window.addEventListener('focus', refresh)
  return () => {
    active = false
    window.clearInterval(interval)
    window.removeEventListener('focus', refresh)
  }
}
